import {
  Box,
  Button,
  Grid,
  Hidden,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/styles";
import React, { useState } from "react";
import TransperantCard from "../TransperantCard/TransperantCard";
import list from "../cardListData";
import { AiFillPlayCircle } from "react-icons/ai";
import FeeDetails from "../FeeDetails/FeeDetails";
import waves from "../../../assets/optimized/Landing/App Section/waves.svg";
import { Link, useHistory } from "react-router-dom";
import TitleAndTradingSlider from "../../TitleAndTradingSlider";
import CheckboxHolder from "../CheckboxHolder/CheckboxHolder";
import CoinDesk from "../../../assets/svgs/Coindesk-logo.svg";
import Inc42 from "../../../assets/svgs/Inc42-logo.svg";
import Forbes from "../../../assets/svgs/Forbes-logo.svg";
import CoinTelegraph from "../../../assets/svgs/CoinTelegraph-logo.svg";
import BloombergQuint from "../../../assets/svgs/BloombergQuint-logo.svg";
import Mint from "../../../assets/svgs/Mint-logo.svg";
import dots from "../../../assets/svgs/background-dots.svg";
import EmailCapture from "../../EmailCapture";
import SVG, { Props as SVGProps } from "react-inlinesvg";
import useResizer from "../../../services/useResizer";

const HoverImage = ({ src, srcOnHover, alt, ...props }) => {
  return (
    <img
      {...props}
      src={src}
      alt={alt}
      onMouseOver={(e) => {
        srcOnHover && (e.currentTarget.src = srcOnHover);
      }}
      onMouseOut={(e) => {
        srcOnHover && (e.currentTarget.src = src || "");
      }}
    />
  );
};

function ThirdDivision() {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const isMobile = useResizer();
  return (
    <div className="bg-[transparent]">
      <Box
        className=" pb-10 pt-5"
        color="white"
        position="relative"
        overflow="hidden"
      >
        <h3 className=" text-center md:hidden" style={{ color: "#8A8A8A" }}>
          {" "}
          In the news
        </h3>{" "}
        <h3
          className="hidden md:block"
          style={{ marginLeft: "60px", color: "#8A8A8A" }}
        >
          In the news
        </h3>
        <div
          className="pb-10  mb-10 mt-10 md:mt-5 flex items-center justify-center md:justify-between flex-wrap gap-y-10 gap-x-5 md:gap-x-2"
          style={{ margin: !isMobile ? "0px 60px" : "" }}
        >
          <HoverImage
            src={CoinDesk}
            style={{ maxWidth: "140px" }}
            srcOnHover={
              require("../../../assets/optimized/Landing/Hero Section/White/coindesk-logo.svg")
                .default
            }
          ></HoverImage>
          <HoverImage
            src={Inc42}
            style={{ maxWidth: "120px" }}
            srcOnHover={
              require("../../../assets/optimized/Landing/Hero Section/White/inc-42-logo.svg")
                .default
            }
          ></HoverImage>{" "}
          <HoverImage
            src={Mint}
            style={{ maxWidth: "120px" }}
            srcOnHover={
              require("../../../assets/optimized/Landing/Hero Section/White/mint-logo.svg")
                .default
            }
          ></HoverImage>
          <HoverImage
            src={BloombergQuint}
            style={{ maxWidth: "170px" }}
            srcOnHover={
              require("../../../assets/optimized/Landing/Hero Section/White/bloomberg-quint-logo.svg")
                .default
            }
          ></HoverImage>
          <HoverImage
            src={Forbes}
            style={{ maxWidth: "140px" }}
            srcOnHover={
              require("../../../assets/optimized/Landing/Hero Section/White/forbes-logo-white.svg")
                .default
            }
          ></HoverImage>
          <HoverImage
            src={CoinTelegraph}
            style={{ maxWidth: "170px" }}
            srcOnHover={
              require("../../../assets/optimized/Landing/Hero Section/White/cointelegraph-logo-white.svg")
                .default
            }
          ></HoverImage>
        </div>
        <div className="relative -mt-10 overflow-hidden">
          <div className={classes.wave}>
            {/* <img src={waves} className="absolute -top-32 z-0"></img> */}
            <div className="container-bt relative z-10">
              <div className="flex flex-wrap justify-between">
                <div className="flex flex-col items-center md:w-[50%] w-full">
                  <div className="mb-14 w-full flex justify-center">
                    <TransperantCard list={list} />
                  </div>

                  <div className="z-10 w-full">
                    <TitleAndTradingSlider />
                  </div>
                </div>
                <div className="flex flex-col items-center md:w-[50%]  w-full mt-10 md:mt-20">
                  <div className="leading-relaxed">
                    <h1 className="text-4xl mb-6">Get What You Pay For!</h1>
                    <h2 className="font-light" style={{ color: "#ccc" }}>
                      Literally{" "}
                      <span className="text-pb-primary-100 ">NO FEES</span> on
                      all trades.
                    </h2>
                    <h3 className="font-light mb-8" style={{ color: "#ccc" }}>
                      Unlimited Trading - Infinite Liquidity - No Slippage
                    </h3>
                    <h2 className="text-pb-primary-100 hover:underline cursor-pointer mb-10 md:mb-0">
                      <Link to="/feespage" className="text-pb-primary-100 ">
                        View All Fees
                      </Link>
                    </h2>
                    <div className="md:absolute bottom-0">
                      <h2>Buy Bitcoin in minutes!</h2>
                      <EmailCapture></EmailCapture>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <img
            src={dots}
            className="absolute right-[50px]  -bottom-44 opacity-20 md:opacity-50 z-0"
          ></img>
        </div>
        {/* <img
        src={waves}
        className="absolute pb-20 mb-10 -bottom-28 w-full z-0"
      ></img> */}
      </Box>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      // marginTop: "-80px",
    },
  },
  rightHeader: {
    // paddingBottom: "20px",
    color: "#C5CDD9",
    marginBottom: "50px",
    [theme.breakpoints.down("md")]: {
      textAlign: "center",
    },
  },
  checkboxes: {
    marginBottom: "50px",
  },
  wave: {
    // transform: " scaleY(-1)",
    // marginBottom: "-550px",
    // marginTop: "-200px",
    // height: "550px",
    backgroundImage: `url('${waves}')`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    width: "100%",
    backgroundPosition: "center -200px",
    [theme.breakpoints.down("sm")]: {
      // backgroundPosition: "-1200px -500px",
      // marginBottom: "-450px",
      // display: "none",
    },
  },
  reverseWave: {
    position: "absolute",
    // zIndex: "100",
    [theme.breakpoints.down("lg")]: {
      top: "15%",
    },
    [theme.breakpoints.down("md")]: {
      top: "50%",
      display: "none",
    },
    // [theme.breakpoints.down("sm")]: {
    //   top: "40%",
    // },
    // [theme.breakpoints.down("xs")]: {
    //   top: "75%",
    // },
    // top: "-9%",
    // left: "-30%",
    // width: "150%",
  },
  feeDetails: { marginBottom: "80px" },
  feesBlock: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
      marginBottom: "50px",
    },
    [theme.breakpoints.up("md")]: {
      marginBottom: "190px",
    },
  },
  detailsBlock: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "100px",
    // alignItems: "center",
    [theme.breakpoints.down("md")]: {
      width: "80%",
    },
    // marginTop: "30px",
    // width: "30%",
  },
  bottomText: {
    [theme.breakpoints.up("sm")]: {
      paddingTop: "2rem",
    },
    // paddingTop: "2rem",
  },
  emailLabel: {
    paddingBottom: "8px",
    borderBottom: "1px solid #444",
  },
  emialHolder: {
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  emailBox: {
    // minWidth: "100%",
    display: "flex",
    height: "70px",
    borderRadius: "24px",
    overflow: "hidden",
    background:
      "radial-gradient(98.09% 98.09% at 31.51% 23.05%, rgba(77, 79, 84, 0.5) 0%, rgba(36, 38, 43, 0.5) 100%)",
    backdropFilter: "blur(40px)",
    WebkitBackdropFilter: "blur(40px)",

    marginTop: "20px",
    marginBottom: "20px",
  },
  submitButton: {
    background: "#3AC4AB",
    height: "100%",
    width: "40%",
    // position: "absolute",
    // right: "1%",
    borderRadius: "24px",
    border: "none",
    color: "#fff",
    textTransform: "capitalize",
  },
  logo: {
    fontSize: "25px",
    paddingRight: "10px",
  },
  emailBoxInputBox: {
    color: "#fff",
    width: "90%",
    margin: "0 auto",
    height: "100%",
    fontSize: "20px",
    border: "none",
    borderRadius: "24px",
    background: "none",
    paddingRight: "94px",
    paddingLeft: "20px",
    "&:focus": {
      outline: "none",
    },
  },
}));
export default ThirdDivision;
